import { RegistrantsTableColumns, SortOrder } from '../../Utils/Constants';
export const GET_SESSION_REGISTRANTS_REQUEST = 'GET_SESSION_REGISTRANTS_REQUEST';
export const GET_SESSION_REGISTRANTS_SUCCESS = 'GET_SESSION_REGISTRANTS_SUCCESS';
export const GET_SESSION_REGISTRANTS_FAILURE = 'GET_SESSION_REGISTRANTS_FAILURE';

const defaultFilter = {
  textSearch: ''
};

const defaultSort = {
  sortBy: RegistrantsTableColumns.REGISTRATION_TIME,
  sortOrder: SortOrder.DESC
};

export function getSessionRegistrantsDetails(sessionKey, pageNumber = 0, filter = defaultFilter, sort = defaultSort) {
  return {
    type: GET_SESSION_REGISTRANTS_REQUEST,
    payload: { sessionKey, pageNumber, filter, sort }
  };
}



// WEBPACK FOOTER //
// ./src/Reducks/SessionRegistrants/SessionRegistrantsActions.js